import store from 'store'

export default {
  notify: notify,
}

export function notify(item) {
  store.dispatch('notifications/addItem', item)
}
